import React from 'react'
import Banner from './components/Banner'
import { CustomButton } from 'styles/global'
import { GiCheckMark } from 'react-icons/gi'
import StepCarousel from './components/StepCarousel'
import Navbar from 'components/Navbar'
import { CorpoConteudo } from 'layouts/simple/style'
import { HashLink } from 'react-router-hash-link'
import { scrollWithOffset } from 'util/scrollWithOffset'

const EmprestimoGarantia = () => {
  return (
    <>
      <Navbar />
      <CorpoConteudo minHeight="calc(100vh - 60px)">
        <Banner
          contentBanner={
            <div className="infos-fgts">
              <div className="container container-produto justify-content-center justify-content-md-between">
                <div className="d-flex flex-column justify-content-center gap-5">
                  <h1>
                    Antecipe seu FGTS com taxas <br /> a partir de 1,99% ao mês.
                  </h1>
                  <h2>
                    Receba agora até 10 parcelas do seu <br /> saque-aniversário
                    direto na conta.
                  </h2>

                  <div className="d-flex justify-content-center w-100">
                    <HashLink
                      to="/#iniciar-simulacao"
                      className="w-100 d-flex justify-content-center no-styled-link"
                      smooth
                      scroll={(el) => {
                        scrollWithOffset(el, 300)
                      }}
                    >
                      <CustomButton
                        background="var(--verde-riber)"
                        borderRadius={25}
                        height="56px"
                        fontSize="30px"
                        maxWidth="350px"
                        width="100%"
                      >
                        Simule agora
                      </CustomButton>
                    </HashLink>
                  </div>
                  <div className="mw-100">
                    <StepCarousel />
                  </div>
                  <div className="d-flex justify-content-center align-items-center gap-3">
                    <span className="tips">
                      <GiCheckMark className="icon" />
                      Liberação rápida e <br /> 100% online
                    </span>
                    <span className="tips">
                      <GiCheckMark className="icon" />
                      Disponível também <br /> para negativados
                    </span>
                    <span className="tips">
                      <GiCheckMark className="icon" />
                      Sem parcelas mensais – o <br />
                      desconto é direto no FGTS
                    </span>
                  </div>
                </div>
                <div className="d-lg-flex d-none flex-column justify-content-center">
                  <img
                    className="img-banner-produto"
                    src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/fgts_1.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          }
        />
      </CorpoConteudo>
    </>
  )
}

export default EmprestimoGarantia
